import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// ── Stale-deploy self-healing ─────────────────────────────────────────────
// Lazy routes load content-hashed chunks. After a redeploy, a tab holding the
// PREVIOUS index.html requests chunk names that no longer exist; the server
// answers with index.html (a "text/html MIME" module error) and every lazy
// route dies until a manual hard refresh. Recover automatically: on the first
// failed dynamic import, reload once to pick up the fresh index. The
// sessionStorage guard (cleared on success) prevents a reload loop when the
// server itself is serving a broken build.
const CHUNK_RELOAD_GUARD = 'chunk-reload-at';
const CHUNK_RELOAD_MIN_INTERVAL_MS = 60_000;
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message ?? event.reason ?? '');
  const isChunkFailure =
    /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(msg);
  if (!isChunkFailure) return;
  // Throttle, don't one-shot: a successful boot must NOT re-arm an immediate
  // reload (boot-ok + lazy-chunk-broken would loop forever). One heal per
  // minute heals every real redeploy and caps a genuinely broken build at a
  // slow, harmless retry.
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_GUARD) || 0);
    if (Date.now() - last < CHUNK_RELOAD_MIN_INTERVAL_MS) return;
    sessionStorage.setItem(CHUNK_RELOAD_GUARD, String(Date.now()));
  } catch { /* storage unavailable - still reload; worst case the loop is browser-throttled */ }
  event.preventDefault();
  console.warn('[app] stale chunk detected after redeploy - reloading for the fresh build');
  location.reload();
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
